import React, { useMemo } from 'react';
import classname from 'classnames';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import Ellipsis from '@wix/da-ds/pkg/Icons/Ellipsis';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Check from '@wix/da-ds/pkg/Icons/16x16/Check';
import IconButtonWithBackground from '@wix/da-ds/pkg/Buttons/IconButton/IconButtonWithBackground';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import UserAvatar from '../../../../User/Avatar/UserAvatarWithPopover';
import UserLink from '../../../../User/Link/UserLinkWithTooltip';
import { getDeviationResourceType, getDeviationTitle } from '../../../_helpers';
import ThumbActions from '../../../Helper/ThumbActions';
import { useWatchButton } from '../../../../WatchButton/useWatchButton';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import FaveControl from '../FaveControl';
import CommentControl from '../CommentControl';
import s from './ThumbOverlayHover.scss';
var ThumbOverlayHover = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, children = _a.children, className = _a.className, extraActions = _a.extraActions, onRemove = _a.onRemove;
    var _b = useOverlayContext(deviation), showTitle = _b.showTitle, showAuthor = _b.showAuthor, showCommentControl = _b.showCommentControl, showAuthorTooltip = _b.showAuthorTooltip, showFaveControl = _b.showFaveControl, showExtraActions = _b.showExtraActions, showAuthorName = _b.showAuthorName, showAuthorWatchButton = _b.showAuthorWatchButton;
    var _c = useWatchButton(deviation.author), isWatching = _c.isWatching, text = _c.text;
    var blockType = useDeviationBlockType(deviation);
    var showSmallerActions = !!height && height < 150;
    var canShowTitle = useMemo(function () {
        if (!showTitle) {
            return false;
        }
        switch (blockType) {
            case 'subsOnly':
            case 'subBlocked':
                return height && height > 250;
            case 'premiumFolder':
                return height && height > 210;
            case 'watchersOnly':
                return height && height > 180;
            default:
                return true;
        }
    }, [blockType, height, showTitle]);
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK, className: classname(s['root'], className), style: { width: width, height: height }, tag: "div" },
        React.createElement("div", { className: s['top'] },
            React.createElement("div", { className: s['left'] }),
            React.createElement(HoverOnly, { className: s['right'] },
                showExtraActions && extraActions && (React.createElement(ThumbActions, { className: s['actions'], deviation: deviation, actions: extraActions },
                    React.createElement(IconButtonWithBackground, { size: showSmallerActions ? 'small' : 'medium', icon: Ellipsis }))),
                onRemove && (React.createElement(IconButtonWithBackground, { className: s['remove-button'], size: "medium", icon: CloseIcon, onClick: onRemove, biData: BiData({
                        evid: 405,
                        typeid: getDeviationResourceType(deviation),
                        itemid: deviation.deviationId,
                        rank: BiContextProvidedValue,
                    }) })))),
        React.createElement(HoverOnly, { className: s['middle'] }, children),
        React.createElement("div", { className: s['bottom'] },
            React.createElement(HoverOnly, { className: s['left'] },
                canShowTitle && (React.createElement(DeviationLink, { deviation: deviation, className: s['title'] },
                    React.createElement(Heading, { className: s['title-heading'] }, getDeviationTitle(deviation)))),
                showAuthor && deviation.author && (React.createElement("div", { className: s['author'] },
                    React.createElement("div", { className: s['avatar-and-username'] },
                        React.createElement(UserAvatar, { user: deviation.author, size: 24, withLink: true, withTooltip: showAuthorTooltip, className: s['avatar'] }),
                        showAuthorName && (React.createElement(UserLink, { user: deviation.author, withTooltip: showAuthorTooltip, className: s['userlink'] }))),
                    isWatching && showAuthorWatchButton && (React.createElement(TextButton, { size: "small", variant: "main", disabled: true, icon: Check }, text))))),
            React.createElement(HoverOnly, { className: classname(s['right'], s['stats']) },
                showCommentControl && (React.createElement(CommentControl, { deviation: deviation, showStatNumbers: true, className: s['stat'] })),
                showFaveControl && (React.createElement(FaveControl, { deviation: deviation, showStatNumbers: true, className: s['stat'] }))))));
};
ThumbOverlayHover.displayName = 'ThumbOverlayHover';
export default ThumbOverlayHover;
//# sourceMappingURL=ThumbOverlayHover.js.map